import { Link } from 'react-router-dom';
import { headerHeight } from '../../utils/theme';
import { useAccount } from '../../auth';

export const Header = ({ layoutState }: { layoutState: string }) => {
  const { currentAccount } = useAccount();
  return (
    <div
      style={{
        // background: 'linear-gradient(to left, #3174AB, #F0FBFF)',
        background:
          'linear-gradient(292deg, #3F7EB1 -462.5%, #3174AB -453.36%, #F0FBFF 86.01%)',
        height: headerHeight,
        overflow: 'hidden',
      }}
    >
      <Link to={`/${currentAccount.name}/flows`}>
        <img
          src={`assets/images/aquifer-logo-${layoutState === 'open' ? 'rgb' : 'mark'}.svg`}
          style={{
            display: 'block',
            maxHeight: '32px',
            // width: '124px',
            // padding: '12px 0',
            ...(layoutState === 'closed'
              ? { margin: '12px 0 0 20px' }
              : { margin: '12px auto' }),
          }}
        />
      </Link>
    </div>
  );
};
